// 导入所有 user 模块的国际化文件
import { messages as vipDetailMessages } from '@/lang/user/vipDetailLang.js'
import { messages as userDetailAddressMessages } from '@/lang/user/userDetailAddressLang.js'
import { messages as userDetailGroupOrdersMessages } from '@/lang/user/userDetailGroupOrdersLang.js'
import { messages as userDetailIntegralDetailMessages } from '@/lang/user/userDetailIntegralDetailLang.js'
import { messages as userDetailIntegralMessages } from '@/lang/user/userDetailIntegralLang.js'
import { messages as userDetailOrderMessages } from '@/lang/user/userDetailOrderLang.js'
import { messages as userDetailRefundGroupOrdersMessages } from '@/lang/user/userDetailRefundGroupOrdersLang.js'
import { messages as userDetailRefundOrderMessages } from '@/lang/user/userDetailRefundOrderLang.js'
import { messages as userDetailSeckillOrdersMessages } from '@/lang/user/userDetailSeckillOrdersLang.js'
import { messages as userDetailVipMessages } from '@/lang/user/userDetailVipLang.js'
import { messages as userMessages } from '@/lang/user/userLang.js'
import { messages as adminShopVipMessages } from '@/lang/user/adminShopVipLang.js'
import { messages as mallUserMessages } from '@/lang/user/mallUserLang.js'
import { messages as shopVipLevelMessages } from '@/lang/user/shopVipLevelLang.js'
import { messages as shopVipUserMessages } from '@/lang/user/shopVipUserLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...vipDetailMessages.en,
        ...userDetailAddressMessages.en,
        ...userDetailGroupOrdersMessages.en,
        ...userDetailIntegralDetailMessages.en,
        ...userDetailIntegralMessages.en,
        ...userDetailOrderMessages.en,
        ...userDetailRefundGroupOrdersMessages.en,
        ...userDetailRefundOrderMessages.en,
        ...userDetailSeckillOrdersMessages.en,
        ...userDetailVipMessages.en,
        ...userMessages.en,
        ...adminShopVipMessages.en,
        ...mallUserMessages.en,
        ...shopVipLevelMessages.en,
        ...shopVipUserMessages.en
    },
    zh: {
        ...vipDetailMessages.zh,
        ...userDetailAddressMessages.zh,
        ...userDetailGroupOrdersMessages.zh,
        ...userDetailIntegralDetailMessages.zh,
        ...userDetailIntegralMessages.zh,
        ...userDetailOrderMessages.zh,
        ...userDetailRefundGroupOrdersMessages.zh,
        ...userDetailRefundOrderMessages.zh,
        ...userDetailSeckillOrdersMessages.zh,
        ...userDetailVipMessages.zh,
        ...userMessages.zh,
        ...adminShopVipMessages.zh,
        ...mallUserMessages.zh,
        ...shopVipLevelMessages.zh,
        ...shopVipUserMessages.zh
    }
} 